// extracted by mini-css-extract-plugin
export default {"adminPromtionOnly":"users_adminPromtionOnly__QQX2o","icon":"users_icon__3vpSA","iconDanger":"users_iconDanger__ohXz6"};